export default {
  'otp.oldPrice': 'Original price ',
  'otp.details': 'Details of the Limited Free Event',
  'otp.effective': 'Effective Time',
  'otp.userTitle': 'Preferential Users',
  'otp.tip':
    'If you have recharged other EngageLab products but did not recharge the OTP, you can still participate in this event.',
  'otp.service.dsc': 'First-Time Users of the OTP Product Recharge Service.',
  'otp.event': 'Event',
  'otp.tip1a': `During the promotion period, users who recharge their OTP for the first time will have the OTP
  Verification fee waived for`,
  'otp.tip1b': '30 natural days',
  'otp.tip1c': 'from the date of recharge.',
  'otp.notes1': '1. One account can only participate in this activity once.',
  'otp.notes2': `2. Once a recharge has been completed, no further refunds are available. If you require
  further assistance, please`,
  'otp.notes2a': 'contact us',
  'otp.notes2b': 'for details.',
  'otp.notes3': `3. EngageLab reserves the right to finalise the interpretation of the campaign within the
  scope of the law.`,
  'email.sem.title': 'Limited Time Offer! 500 Free Emails/day for New Users',
  'email.sem.btn': 'Start Now',
};
